import { Link } from '@tanstack/react-router'

interface PageTab {
  label: string
  to: string
}

// Tab-style navigation between sibling manage pages. Each tab is its own route,
// so existing URLs, guards, and deep links keep working - the tabs simply make
// related pages read as one place (Bookings/Requests, Rooms/Buildings,
// Settings/Audit) instead of separate menu items.
export function PageTabs({ tabs, active }: { tabs: PageTab[]; active: string }) {
  return (
    <nav aria-label="Page sections" className="flex items-center gap-2 border-b border-gray-200 mb-6 overflow-x-auto">
      {tabs.map((tab) => (
        <Link
          key={tab.to}
          to={tab.to}
          aria-current={active === tab.to ? 'page' : undefined}
          className={`px-4 py-3 text-sm font-semibold whitespace-nowrap border-b-2 transition-colors ${
            active === tab.to
              ? 'border-gray-900 text-gray-900'
              : 'border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300'
          }`}
        >
          {tab.label}
        </Link>
      ))}
    </nav>
  )
}
